import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';

interface DatenverwaltungPartnerZuordnungProps extends React.ClassAttributes<any> {
    data: any;
}

export interface DatenverwaltungPartnerZuordnungState {
    bundle: any;
    partner: any;
}

export class DatenverwaltungPartnerZuordnung extends React.Component<DatenverwaltungPartnerZuordnungProps, DatenverwaltungPartnerZuordnungState> {

    constructor(props: any) {
        super(props);
        this.state = {
            bundle: null,
            partner: null
        };
        this.customFormatter = this.customFormatter.bind(this);
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    componentDidMount(): void {
        this.init();
    }

    customFormatter(field: string, value: any, data: any, row: any): any {
        return field === 'partner' && ((this.state.partner || {})[value] || []).length > 1
            ? `${value} (${this.state.partner[value].indexOf(data.partner_orig || data.partner) + 1})`
            : value;
    }

    init(): void {
        const data: any = {};
        const partner: any[] = [];

        ((this.props.data || {})[IDs.ENT_PARTNER] || [])
            .sort((a: any, b: any) => a.tid - b.tid)
            .forEach((item: any) => {
                if (typeof data[item.name] === 'undefined') {
                    data[item.name] = [];
                }
                data[item.name].push(item.tid);
            });

        ((this.props.data || {})[IDs.ENT_PARTNER] || []).forEach((item: any, index: number) => {
            const name: string = item.name || null;
            partner.push(item);
            partner[index].name = data[name].length > 1
                ? `${name} (${data[name].indexOf(item.tid) + 1})`
                : name;
        });
        this.setState({ bundle: { partner }, partner: data });
    }

    render(): JSX.Element {
        if (!this.state.bundle) {
            return null;
        }

        return (
            <WFormsTableWrapper
                entity={IDs.ENT_PARTNER_ZUORDNUNG}
                module={IDs.MOD_ETOOL_ADMIN}
                actions={['add', 'edit', 'delete']}
                formLayout='flowV2'
                customClass='Custom-ETA'
                bundleFilterFunc={(bundle: any) => bundle.partner = this.state.bundle.partner || bundle.partner}
                onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_PARTNER_ZUORDNUNG)}
                customFormatter={this.customFormatter}
                showColumnsHelp
            />
        );
    }
}
